
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.737 16.81c-1.613 0-3.061-.355-4.346-1.066a7.954 7.954 0 01-2.952-2.993c-.683-1.285-1.025-2.733-1.025-4.346s.342-3.048 1.025-4.305a7.583 7.583 0 012.952-2.993C31.676.369 33.124 0 34.737 0s3.048.369 4.305 1.107A7.244 7.244 0 0141.994 4.1c.71 1.257 1.066 2.692 1.066 4.305 0 1.613-.355 3.061-1.066 4.346-.683 1.257-1.667 2.255-2.952 2.993-1.257.71-2.692 1.066-4.305 1.066zM.83.41h4.428L18.46 22.919V.41h3.936v28.7h-4.428L4.766 6.601V29.11H.83V.41zm33.907 13.161c1.394 0 2.542-.451 3.444-1.353.93-.902 1.394-2.173 1.394-3.813 0-1.64-.465-2.911-1.394-3.813-.902-.902-2.05-1.353-3.444-1.353-1.394 0-2.556.451-3.485 1.353-.902.902-1.353 2.173-1.353 3.813 0 1.64.451 2.911 1.353 3.813.93.902 2.091 1.353 3.485 1.353zm-7.298 5.904h14.637v3.28H27.44v-3.28zM51.246 5.904a5.462 5.462 0 01-2.214 1.189c-.793.191-1.886.287-3.28.287V4.1h.656c1.476 0 2.61-.287 3.403-.861.792-.601 1.27-1.544 1.435-2.829h3.936v28.7h-3.936V5.904z","fill":"#9B9B9B"}})])
          )
        }
      }
    